export function accountPath(accountId, subPath = '') {
  if (!accountId) return '/login';
  const path = subPath.startsWith('/') ? subPath : subPath ? `/${subPath}` : '';
  return `/account/${accountId}${path}`;
}

export function isSuperAdmin(user) {
  return user?.role === 'SUPER_ADMIN';
}
